import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { BookingsWidget } from './BookingsWidget'

/**
 * <holdstyring-bookings> Web Component
 *
 * Displays user's upcoming bookings with cancel functionality.
 *
 * Attributes:
 *   api-key: Required. Your Holdstyring API key.
 *   theme-primary: Optional. Primary color (hex).
 *
 * Events (dispatched on window):
 *   holdstyring-widget-booking-cancelled: Fired when a booking is cancelled
 *     (detail.bookingId, detail.className).
 *
 * Example:
 *   <holdstyring-bookings api-key="wk_live_xxx"></holdstyring-bookings>
 */
class HoldstyringBookingsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return BookingsWidget
  }
}

// Register the custom element
if (!customElements.get('holdstyring-bookings')) {
  customElements.define('holdstyring-bookings', HoldstyringBookingsElement)
}

export { HoldstyringBookingsElement }
